module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-11-21 at 4.32.04 PM (1).1a14620a.jpeg";